import "/__w/1/s/BotFramework-WebChat/packages/component/src/Attachment/Text/private/ViewCodeDialog.module_built.css";
const classes = {"view-code-dialog":"wyq2fIq_view-code-dialog","view-code-dialog__title":"wyq2fIq_view-code-dialog__title","view-code-dialog__body":"wyq2fIq_view-code-dialog__body","view-code-dialog__footer":"wyq2fIq_view-code-dialog__footer","view-code-dialog__header":"wyq2fIq_view-code-dialog__header"}
export default classes

const _view_code_dialog0 = classes["view-code-dialog"]
export { _view_code_dialog0 as "view-code-dialog" }

const _view_code_dialog__title0 = classes["view-code-dialog__title"]
export { _view_code_dialog__title0 as "view-code-dialog__title" }

const _view_code_dialog__body0 = classes["view-code-dialog__body"]
export { _view_code_dialog__body0 as "view-code-dialog__body" }

const _view_code_dialog__footer0 = classes["view-code-dialog__footer"]
export { _view_code_dialog__footer0 as "view-code-dialog__footer" }

const _view_code_dialog__header0 = classes["view-code-dialog__header"]
export { _view_code_dialog__header0 as "view-code-dialog__header" }
